
import { ITask } from '../../../data_models/task'
import { EProjectStatus, IProject } from '../../../data_models/project'

import { useEffect, useState } from 'react';
import RichText from '../../common/RichText';
import { FilledButton, OutlinedButton, TextButton } from '../../common/Button';
import RichTextEditor from '../../common/RichTextEditor';
import IconButton from '../../common/IconButton';
import { IoMdClose } from 'react-icons/io';
import { IoMdCheckmark } from 'react-icons/io';
import { FiEdit3 } from 'react-icons/fi';
import { IoPencil } from 'react-icons/io5';
import useProjects from '../../../hooks/useProjects';
import MultiTextSelect from '../../common/MultiTextSelect';
import { Chip } from '../../common/Chip';

export const ProjectDetailsChat: React.FC<{
    isPm: boolean,
    isEmployer: boolean,
    isFreelancer: boolean,
    isOutsider: boolean,
    project: IProject,
    setProject: (project: IProject) => void,
}> = ({ isPm, isEmployer, isFreelancer, isOutsider, project, setProject }) => {

    return (
        <div className="p-4 overflow-hidden rounded-lg bg-white shadow-lg border border-gray-200">
            <h3>Chat</h3>
        </div>


    )
}